import { infiniteQueryOptions, keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

import { getSurveysReport, PAGE_SIZE, type ReportFilters } from '../api/reportsApi'
import { nextReportOffset } from '../lib/reports-paging'
import { reportsScopeParams } from '../lib/reports-scope'

import type { SurveyReportStatus } from '../api/types'

export const surveysReportQueryOptions = (filters: ReportFilters, status: SurveyReportStatus) =>
  infiniteQueryOptions({
    queryKey: ['gis', 'reports', 'surveys', status, reportsScopeParams(filters.scope, { mandal: filters.mandal })] as const,
    queryFn: ({ pageParam }) => getSurveysReport(filters, status, pageParam),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      nextReportOffset(allPages.reduce((sum, p) => sum + p.rows.length, 0), lastPage.totalCount, lastPage.rows.length, PAGE_SIZE),
    staleTime: 1000 * 60 * 2,
    placeholderData: keepPreviousData,
  })

export function useSurveysReport(filters: ReportFilters, status: SurveyReportStatus) {
  return useInfiniteQuery(surveysReportQueryOptions(filters, status))
}
